import { GlobalQuestionLibraryApi } from 'api/GlobalQuestionLibraryApi';
import { backendApiClient } from 'container/backendApiClient';

export const globalQuestionLibraryApi = new GlobalQuestionLibraryApi(backendApiClient);
